export default function MissionVision() {
  return (
    <section id="mission" className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <strong className="text-teal-600">Mission & Vision</strong>
          </h2>
          <div className="w-24 h-1 bg-teal-600 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 shadow-lg border border-teal-100 hover:shadow-xl transition-all">
            <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-rocket-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
            <p className="text-gray-700 leading-relaxed text-lg">
              To deliver quality export products with consistency and trust. We are committed to maintaining 
              the highest standards in every shipment, ensuring our clients receive premium rice, spices, and 
              wheat that meet international quality benchmarks.
            </p>
          </div>

          <div className="bg-gradient-to-br from-amber-50 to-white rounded-2xl p-8 shadow-lg border border-amber-100 hover:shadow-xl transition-all">
            <div className="w-16 h-16 bg-amber-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-eye-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Vision</h3>
            <p className="text-gray-700 leading-relaxed text-lg">
              To become a reliable worldwide export partner. We aspire to build lasting relationships with 
              buyers across the globe by consistently delivering excellence in product quality, packaging, 
              and timely delivery services.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
